import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'react-images';
import { withSize } from 'react-sizeme';

import layoutGeometry from 'justified-layout';

class Gallery extends React.Component {
    static propTypes = {
        images: PropTypes.shape({
            thumbnails: PropTypes.arrayOf(PropTypes.object),
            fullsize: PropTypes.arrayOf(PropTypes.object)
        }).isRequired
    };

    state = { lightboxIsOpen: false, currentImageIndex: 0, currentGallery: 'children' };

    openLightbox = (index, event) => {
        event.preventDefault();
        this.setState({
            currentImageIndex: index,
            lightboxIsOpen: false
        });
    };
    closeLightbox = () => {
        this.setState({
            currentImageIndex: 0,
            lightboxIsOpen: false
        });
    };
    prevImage = () => {
        this.setState(prevState => ({
            currentImageIndex: --prevState.currentImageIndex
        }));
    };
    nextImage = () => {
        this.setState(prevState => ({
            currentImageIndex: ++prevState.currentImageIndex
        }));
    };

    viewImage = index => {
        this.setState({
            currentImageIndex: index,
            lightboxIsOpen: true
        });
    };

    render() {
        const { images, size } = this.props;
        const { lightboxIsOpen, currentImageIndex } = this.state;

        const layout = layoutGeometry(images.thumbnails, {
            containerWidth: size.width,
            targetRowHeight: 200
        });

        return (
            <div>
                <div className="relative" style={{ height: layout.containerHeight }}>
                    {images.thumbnails.map((img, index) => (
                        <img
                            alt="By Alan Honey Photography"
                            onClick={() => this.viewImage(index)}
                            className="m1"
                            css={{ position: 'absolute', cursor: 'zoom-in' }}
                            style={layout.boxes[index]}
                            key={index}
                            src={img.src}
                        />
                    ))}
                </div>
                <Lightbox
                    currentImage={currentImageIndex}
                    isOpen={lightboxIsOpen}
                    images={images.fullsize.map(img => ({ src: img.src }))}
                    onClose={this.closeLightbox}
                    onClickPrev={this.prevImage}
                    onClickNext={this.nextImage}
                />
            </div>
        );
    }
}

export default withSize()(Gallery);



// WEBPACK FOOTER //
// ./src/pages/Galleries/components/Gallery/index.js